import httpClient from './httpClient';

export const ADDRESS_ENDPOINT = '/backoffice/provinces';

export const getProvincesAPI = async () => httpClient.get(ADDRESS_ENDPOINT);
